import PageNode from './PageNode';
import ContactUsNode from './ContactUsNode';
import ActionNode from './ActionNode';
import NoteNode from './NoteNode';
import IfNode from './IfNode';
import BranchNode from './BranchNode';
import DecisionPointNode from './DecisionPointNode';
import DefaultNode from './DefaultNode';
import BranchStubNode from './BranchStubNode';
import EndNode from './EndNode';

import StartNode from './StartNode';

export const nodeTypes = {
  page: PageNode,
  contactUs: ContactUsNode,
  action: ActionNode,
  note: NoteNode,
  if: IfNode,
  branch: BranchNode,
  decisionPoint: DecisionPointNode,
  start: StartNode,
  end: EndNode,
  branchStub: BranchStubNode,
  default: DefaultNode,
};

export { PageNode, ContactUsNode, ActionNode, NoteNode, IfNode, BranchNode, DecisionPointNode, StartNode, EndNode, BranchStubNode, DefaultNode };
